import 'react-quill/dist/quill.snow.css'
import PolicyEditor from '../../../Utilities/PolicyEditor'

const CustomerSupport = () => {
  return <PolicyEditor title="Customer Support" fieldKey="customerSupport" />
}

export default CustomerSupport
